import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import createSagaMiddleware from "redux-saga";
import rootReducer from './reducers'
import rootSaga from '../sagas'
import config from '../modules/config'
import { analyticsLogger } from '../modules/analytics'

export const history = createHistory({
  basename: config.basename
})

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()

const initialState = {}
const middleware = [
  sagaMiddleware,
  thunk,
  routerMiddleware(history),
  analyticsLogger
]
const enhancers = []

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

// @see https://github.com/facebook/create-react-app/issues/2317
const configureStore = () => {
  const store = createStore(
    rootReducer,
    initialState,
    composedEnhancers
  )
  sagaMiddleware.run(rootSaga)

  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept('./reducers', () => {
        store.replaceReducer(rootReducer)
      })
    }
  }

  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.js